export default __webpack_public_path__ + "static/media/pexels-axecop-2697598.eb986e3b.jpg";